// extracted by mini-css-extract-plugin
export default {"card":"Card_card__aWnWl","cardHeadingSecondary":"Card_cardHeadingSecondary__ls0C9","cardHeadingPrimary":"Card_cardHeadingPrimary__pdfB-","cardText":"Card_cardText__d66tT"};